import api from './api';

export type EquipmentReportRow = Record<string, string | number | null> & { recno: number };
export interface EquipmentReportData {
  rows: EquipmentReportRow[];
  columns: string[];
}

export async function getEquipmentReport(includeDeleted: boolean, signal: AbortSignal) {
  const response = await api.get<EquipmentReportData>('/equipment/report', {
    params: { include_deleted: includeDeleted }, signal,
  });
  return response.data;
}
